export default "__VITE_ASSET__04ac4c70__"